import { addMinutes } from 'date-fns';

export const parseDateToUtc = (input?: string | null): Date => {
  const date = input ? new Date(input) : new Date();
  const offset = date.getTimezoneOffset();

  return addMinutes(date, offset);
};
